module.exports = __webpack_public_path__ + "static/img/shoes_left_green.cc318b26.png";